<template>
    <div class="pt-3 p-md-3">
        <!-- cover card -->
        <div class="row">
            <div class="col">
                <div class="card rounded-lg position-relative">
                    <div class="card-img-top profile-cover cover">
                        <img :src="profileUser?.coverPicture || urlGenerator('/images/default-cover.png')" class=""
                             alt="cover image"/>
                    </div>
                    <!-- profile picture -->
                    <div class="avatar d-flex flex-column flex-md-row align-items-center gap-x-1"
                         style="pointer-events: none;">
                        <div class="rounded-circle profile-uploader position-relative" style="pointer-events: auto;">
                            <img :src="getImg(profileUser)" alt="pp">
                        </div>
                        <div class="text-white text-center text-md-left">
                            <h4 class="p-0 m-0">{{ profileUser.full_name }}</h4>
                        </div>
                    </div>
                    <div class="card-footer bg-transparent">
                        <div class="d-flex justify-content-center justify-content-md-end">
                            <a :href="urlGenerator('/profile/' + profileUser.uuid)" class="btn btn-link py-0"
                               :class="{ 'text-primary': location.pathname.split('/').includes('profile') }">
                                <app-icon class="mr-1" name="user"/>
                                Profile</a>
                            <a :href="urlGenerator('/gallery/' + profileUser.uuid)" class="btn btn-link py-0"
                               :class="{ 'text-primary': location.pathname.split('/').includes('gallery') }">
                                <app-icon class="mr-1" name="image"/>
                                Gallery</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- content -->
        <div class="row mt-3">
            <div class="col-12 col-md-5 col-lg-4">
                <div class="card rounded-lg">
                    <div class="card-body">
                        <h3>About</h3>
                        <div>
                            <p v-if="profileUser.profile?.about">{{
                                    profileUser.profile?.about
                                }}</p>
                            <p class="text-muted" v-else>{{ $t('nothing_to_show') }}</p>
                        </div>
                        <div class="d-flex flex-column gap-y-1">
                            <div v-if="profileUser.profile?.gender" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="shuffle"/>
                                </div>
                                <span class="bold">{{ $t(profileUser.profile?.gender) }}</span>
                            </div>
                            <div v-if="profileUser.address?.address" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="map-pin"/>
                                </div>
                                Live at <span class="bold">{{ profileUser.address?.address }}</span>
                            </div>
                            <div v-if="profileUser.email" class="d-flex">

                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="mail"/>
                                </div>
                                <a :href="'mailto:'+profileUser.email">{{ profileUser.email }}</a>
                            </div>

                            <div v-if="profileUser.contact" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="phone"/>
                                </div>
                                <a :href="'tel:'+profileUser.contact">{{ profileUser.contact }}</a>
                            </div>

                            <div v-if="profileUser?.profile?.date_of_birth" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="gift"/>
                                </div>
                                <span>{{ formatDateToLocal(profileUser.profile.date_of_birth) }}</span>
                            </div>

                            <div v-for="social in visibleSocialLinks" class="d-flex align-items-center">
                                <div class="avatar-sm">
                                    <app-icon class="mr-1 mr-md-2" :size="20" :name="social.icon"/>
                                </div>
                                <a :href="social.link" target="_blank" class="text-truncate">{{ social.link }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-7 col-lg-8 mt-3 mt-md-0 pl-3 pl-md-0">
                <div class="d-flex flex-column gap-y-1">
                    <div class="d-flex flex-column gap-y-1">
                        <app-pre-loader v-if="loading"/>
                        <template v-else>
                            <post-view v-for="(post, index) in posts" :post="post" :recent="post.recent"
                                       :key="`post-items-${post.id}`" @edit="edit" @del="del"/>
                        </template>
                        <app-empty-data-block v-if="!posts.length && !loading"
                                              :message="$t('empty_data_block_post')"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '../../../../../core/components/buttons/AppButton.vue';
import NewPost from "../feed/NewPost";
import PostView from "../feed/PostView";
import {mapGetters, mapActions} from 'vuex'
import {axiosPost, urlGenerator} from "../../../../helpers/AxiosHelper";
import {COVER_PICTURE_CHANGE, PROFILE_PICTURE_CHANGE} from "../../../../config/ApiUrl";
import EditPostModal from "../feed/EditPostModal.vue";
import {formatDateToLocal} from "../../../../helpers/DateTimeHelper";

export default {
    components: {AppButton, NewPost, PostView, EditPostModal},
    props: {
        profileUser: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            location,
            urlGenerator,
            formatDateToLocal,
            selectedPostId: null
        };
    },
    methods: {
        ...mapActions({
            getLoginUser: 'getUser'
        }),
        profilePictureChange() {
            let input = document.createElement('input')
            input.type = 'file'
            input.accept = '.jpg, .png, .gif, .webp, .jpeg'
            input.click();
            input.addEventListener('change', (event) => {
                let avatar = event.target.files[0]
                let formData = new FormData();
                formData.append('profile_picture', avatar)
                axiosPost(PROFILE_PICTURE_CHANGE, formData).then(res => {
                    console.log(res)
                }).finally(() => {
                    this.getLoginUser()
                })
            })
        },
        coverChange() {
            let input = document.createElement('input')
            input.type = 'file'
            input.accept = '.jpg, .png, .gif, .webp, .jpeg'
            input.click();
            input.addEventListener('change', (event) => {
                let cover = event.target.files[0]
                let formData = new FormData();
                formData.append('cover_picture', cover)
                axiosPost(COVER_PICTURE_CHANGE, formData).then(res => {
                    console.log(res)
                }).finally(() => {
                    this.getLoginUser()
                })
            })
        },
        getImg(user) {
            return user.profile_picture?.full_url ? user.profile_picture.full_url : urlGenerator('/images/avatar-demo.jpg');
        },
        del(id) {
            console.log(id)
            this.$store.dispatch('posts/delPost', id).then(res => {
                this.$toastr.s(res.data.message)
            }).finally(() => {
            })
        },
        edit(id) {
            this.selectedPostId = id
            this.openModal()
        },
    },
    computed: {
        ...mapGetters({
            loading: 'posts/loading',
            posts: 'posts/list',
            user: 'loggedInUser'
        }),
        visibleSocialLinks() {
            let links = []
            if (this.profileUser.socialLinks) {
                let socialLinks = this.profileUser.socialLinks
                socialLinks.forEach(link => {
                    if (link.pivot?.link) {
                        links.push({
                            icon: link.icon,
                            link: link.pivot.link
                        })
                    }
                })
            }
            return links
        }
    },
    mounted() {
        let _this = this
        window.addEventListener('scroll', _.debounce(function (e) {
            let scrollHeight = 944;
            let scrollBarPos = window.scrollY
            let totalHeight = window.document.body.clientHeight - scrollHeight
            if ((scrollBarPos + 20) > totalHeight) {
                if(!_this.loading) {
                    _this.$store.dispatch('posts/getAll', { loader: true, id: this.profileUser?.id })
                        .finally(() =>{})
                }
            }
        }, 500))
    },
    created() {
        this.$store.dispatch('posts/getAll', {id: this.profileUser?.id})
    }
};
</script>
<style scoped lang="scss">

.avatar {
    position: absolute;
    bottom: 52px;
    width: 100%;

    img {
        width: 72px;
        height: 72px;
    }
}

.rounded-lg {
    border-radius: 15px !important;
    overflow: hidden;
}

.profile-cover {
    object-fit: cover;
    img{
        min-height: 148px;
        max-height: 148px;
    }
}

.bold {
    font-weight: bold !important;
}

.profile-uploader {
    cursor: pointer;
    overflow: hidden;

    &--text {
        transition: .2s ease-in;
        display: flex;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #00000080;
        z-index: 900;
        color: #fff;
    }

    &:hover {
        .profile-uploader--text {
            opacity: 1;
        }
    }
}

.cover {
    overflow: hidden;
    position: relative;

    img {
        width: 100%;
        object-fit: cover;
    }

    &-change-button {
        opacity: 0;
        top: 10px;
        left: 10px;
    }

    &:hover .cover-change-button {
        opacity: 1;
    }
}

.cover-change-button {
}

@media screen and (min-width: 768px) {
    .profile-cover {
        max-height: 200px;
        height: auto;
    }

    .avatar {
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: auto;

        img {
            width: 112px;
            height: 112px;
        }
    }
}
</style>